import { useDateRangeStore } from "./use-date-range-store";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";
import { Button } from "@/components/ui/button/button";
import { Calendar } from "@/components/ui/calendar/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { cn } from "@/lib/utils";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { SelectSingleEventHandler } from "react-day-picker";
import { useState } from "react";
import { toast } from "sonner";

export const DateRangePicker = () => {
  const { date, setDate } = useDateRangeStore();

  const [open, setOpen] = useState(false);

  const [selectedDate, setSelectedDate] = useState<Date | undefined>(date);

  const handleSave = () => {
    if (!selectedDate) {
      return toast.error("Select a date");
    }

    setDate(selectedDate);
    setOpen(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>
        <Button
          id="date"
          variant="outline"
          className={cn(
            "w-[260px] justify-start text-left font-normal",
            !selectedDate && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {selectedDate ? (
            format(selectedDate, "LLL dd, y")
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Pick date</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="grid gap-4 py-4">
          <div className={"grid grid-cols-4 items-center gap-1"}>
            <label htmlFor="name" className={"text-left col-span-2"}>
              Date
            </label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className={cn(
                    "col-span-full justify-start text-left font-normal flex items-center gap-2 w-full",
                    !selectedDate && "text-muted-foreground"
                  )}
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {selectedDate ? (
                    format(selectedDate, "PPP")
                  ) : (
                    <span>Pick a date</span>
                  )}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0">
                <Calendar
                  mode="single"
                  selected={selectedDate as Date}
                  onSelect={setSelectedDate as SelectSingleEventHandler}
                />
              </PopoverContent>
            </Popover>
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel
            onMouseDown={() => {
              setDate(date);
            }}
          >
            Cancel
          </AlertDialogCancel>
          <Button
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();

              handleSave();
            }}
          >
            Save
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
